export default __webpack_public_path__ + "static/media/logo_blablacar_bus.2d4867fc.svg";